import Tooltip from '@material-ui/core/Tooltip';
import WarningIcon from '@material-ui/icons/Warning';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../../core/withGShoc';
import LabelSlat from './LabelSlat';

class Label extends React.Component {

    render() {

        const { data, onSelect, selected, schemeIRI, useWorkflow } = this.props;

        // If somebody else has deleted it we will now hide it
        if (data.pendingDeletion) return null;

        return (
            <div>
                <div style={{ width: 24, display: 'inline-block', verticalAlign: 'super' }}>
                    {
                        schemeIRI && (!data.inScheme || !data.inScheme.includes(schemeIRI)) ?
                            <Tooltip data-test="removed-from-scheme" title="This has recently been removed from this scheme.">
                                <WarningIcon />
                            </Tooltip>
                            :
                            null
                    }
                </div>
                <LabelSlat
                    schemeIRI={schemeIRI}
                    data={data}
                    workflowStatus={useWorkflow && data.status ? data.status[0] : undefined}
                    useWorkflow={useWorkflow}
                    selected={selected}
                    onSelect={onSelect} />
            </div>
        );
    }
}

Label.propTypes = {
    schemeIRI: PropTypes.string,
    selected: PropTypes.bool,
    useWorkflow: PropTypes.bool,
    data: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired
};

export default withGS(Label, ["ALL"], ["id", "literalForm", "hasEntitlement", "inScheme", "status"]);